import Plugin from 'src/plugin-system/plugin.class';
import Swiper from 'swiper/bundle';

/**
 * Hero im Slider-Modus: Bilder wechseln per Swiper (Fade), die passende
 * Slide-Überschrift im Inhaltsbereich wird über is--active umgeschaltet.
 */
export function initHeroSlider(el) {
    if (el.swiper) {
        return el.swiper;
    }

    let options = {};
    try {
        options = JSON.parse(el.dataset.heroSliderOptions || '{}');
    } catch (e) {
        options = {};
    }

    const hero = el.closest('.hero-widget');
    const titles = hero ? hero.querySelectorAll('.hero-widget__slide-title') : [];
    const slideCount = el.querySelectorAll('.swiper-slide').length;

    const setActiveTitle = (index) => {
        titles.forEach((title, i) => {
            title.classList.toggle('is--active', i === index);
            title.setAttribute('aria-hidden', i === index ? 'false' : 'true');
        });
    };

    return new Swiper(el, {
        effect: 'fade',
        fadeEffect: { crossFade: true },
        speed: 1000,
        loop: slideCount > 1,
        allowTouchMove: slideCount > 1,
        autoplay: options.autoplay ? {
            delay: options.delay || 5000,
            disableOnInteraction: false,
        } : false,
        pagination: options.pagination && hero ? {
            // Liegt außerhalb des Sliders, sonst wäre sie unter dem Inhaltslayer
            el: hero.querySelector('.hero-widget__slider-pagination'),
            clickable: true,
        } : false,
        on: {
            slideChange(swiper) {
                setActiveTitle(swiper.realIndex);
            },
        },
    });
}

export default class HeroSliderPlugin extends Plugin {
    init() {
        initHeroSlider(this.el);
    }
}
